var map = {
	"./collaborators-set-controller.js": 367,
	"./collaborators-set-controller.js.coffee": 367,
	"./create-lti-redirect-controller": 368,
	"./create-lti-redirect-controller.ts": 368,
	"./edit-distractors-controller": 369,
	"./edit-distractors-controller.ts": 369,
	"./edit-module-controller.js": 370,
	"./edit-module-controller.js.coffee": 370,
	"./history-controller.js": 371,
	"./history-controller.js.coffee": 371,
	"./item-import-controller.js": 372,
	"./item-import-controller.js.coffee": 372,
	"./items-controller.js": 373,
	"./items-controller.js.coffee": 373,
	"./new-module-controller.js": 374,
	"./new-module-controller.js.coffee": 374,
	"./partner-editor-controller.js": 375,
	"./partner-editor-controller.js.coffee": 375,
	"./series-controller.js": 376,
	"./series-controller.js.coffee": 376,
	"./set-index-controller.js": 377,
	"./set-index-controller.js.coffee": 377,
	"./show-series-controller.js": 378,
	"./show-series-controller.js.coffee": 378,
	"./show-set-controller.js": 379,
	"./show-set-controller.js.coffee": 379
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 789;